import { fromJS } from "immutable";

export default fromJS({
	opera: "/browser/opera/opera.png",
	chrome: "/browser/chrome/chrome.png",
	metasr: "/browser/chrome/chrome.png", // I think this is actually chrome
	yandex: "/browser/yandex/yandex.png",
	safari: "/browser/safari/safari.png",
	firefox: "/browser/firefox/firefox.png",
	vivaldi: "/browser/vivaldi/vivaldi.png",
	edge: "/browser/edge/edge.png",
	ieMobile: "/browser/edge/edge.png",
	mobileSafari: "/browser/safari-ios/safari-ios.png",
	ie: "/browser/archive/internet-explorer_9-11/internet-explorer_9-11.png",
	default: "/browser/web/web.png",
});
